module.exports = __webpack_public_path__ + "img/ktr.65963cfc.jpg";